export default "__VITE_PUBLIC_ASSET__93ed4cf6__"